module.exports = __webpack_public_path__ + "img/cacahuate.acc6a9f9.png";